import { createSelector } from 'reselect';
import { IMatzevaState } from 'types/matzeva.types';
import { IMatzevaFormData } from 'views/public/MatzevaView/components/MatzevaForm/types';

const getItems = (state: { matzeva: IMatzevaState }) => state.matzeva.items;
const getSelectedItem = (state: { matzeva: IMatzevaState }) => state.matzeva.selectedItem;
const getCementeries = (state: { matzeva: IMatzevaState }) => state.matzeva.cementeries;

export const matzevaSelector = createSelector([getItems], (matzeva) => matzeva);

export const matzevaFormSelector = createSelector(
  [getSelectedItem],
  (matzeva): IMatzevaFormData => ({
    person: {
      id: matzeva?.person?.id || 0,
      name: matzeva?.person?.name || '',
      lastName: matzeva?.person?.lastName || '',
      motherName: matzeva?.person?.motherName || '',
      deathDate: matzeva?.person?.deathDate || '',
      deathDateHebrew: matzeva?.person?.deathDateHebrew || '',
    },
    cementery: {
      cementery: matzeva?.cementery?.cementery || '',
      location: matzeva?.cementery?.location || '',
      sketch: matzeva?.cementery?.sketch || '',
    },
    details: {
      text: matzeva?.details?.text || '',
      marbleWorkerName: matzeva?.details?.marbleWorkerName || '',
      color: matzeva?.details?.color || '',
      materials: matzeva?.details?.materials || '',
      dimensions: matzeva?.details?.dimensions || '',
    },
    applicantName: matzeva?.applicantName || '',
    comments: matzeva?.comments || '',
  }),
);

export const matzevaCementeriesSelector = createSelector([getCementeries], (cementeries) =>
  Object.keys(cementeries).map((key) => ({
    label: cementeries[key],
    value: key,
  })),
);

export const matzevaFilesSelector = createSelector([getSelectedItem], (matzeva) => ({
  cementerySketchFile: matzeva?.cementery?.sketchFile || '',
  cementerySpanishFile: matzeva?.cementery?.spanishFile || '',
  cementeryHebrewFile: matzeva?.cementery?.hebrewFile || '',
  detailsMatzevaFile: matzeva?.details?.matzevaFile || '',
}));
